import React, { useState } from 'react';
import PageLayout from '../Components/PageLayout';
import './TrusteeCertificate.css';

const PDF_URL =
  'https://ebullion-preprod.s3.ap-south-1.amazonaws.com/assets/trustee-certificate.png';

const faqs = [
  {
    question: 'What is the role of a Trustee in digital precious metals?',
    answer:
      'A Trustee acts as a custodian for customers\' interests, verifying that sufficient physical stock exists to back 100% of the digital precious metals issued.',
  },
  {
    question: 'How do I know the precious metals I bought exists?',
    answer:
      'You can download the latest Trustee Certificate confirming independent physical verification of vault-stored precious metals and silver.',
  },
  {
    question: 'Is my investment safe if CoinBazaar powered by eBullion faces financial issues?',
    answer:
      'Yes. Customer metals are held with an independent custodian and remain protected. If operations cease, metals are liquidated and proceeds distributed to investors based on holdings.',
  },
];

const TrusteeCertificate = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) =>
    setOpenFaq((prev) => (prev === index ? null : index));

  return (
    <PageLayout page="trustee-certification">
      <div className="tc-wrapper">

        {/* ── PAGE HEADER ── */}
        <div className="tc-page-header">
          <span className="tc-eyebrow">Security &amp; Transparency</span>
          <h1 className="tc-page-title">Trustee Certificate &amp; Security Assurance</h1>
          {/* <p className="tc-page-subtitle">
            Every milligram you invest is verified, backed, and protected by an independent trustee structure.
          </p> */}
        </div>

        {/* ── HERO: CERTIFICATE + CONTENT ── */}
        <section className="tc-hero-section">

          {/* LEFT — PDF viewer */}
          <div className="tc-pdf-panel">
            {/* <div className="tc-pdf-label">
              <span className="tc-pdf-dot" />
              Independent Trustee Certificate — Jan 2026
            </div> */}
            <div className="tc-pdf-frame">
              <img
  src={PDF_URL}
  alt="Trustee Certificate"
  className="tc-pdf-image"
/>
            </div>
            <a
              href={PDF_URL}
              target="_blank"
              rel="noreferrer"
              className="tc-download-btn"
            >
              Download Certificate
            </a>
          </div>

          {/* RIGHT — Text content */}
          <div className="tc-content-panel">
            <p className="tc-p">
              At CoinBazaar powered by eBullion, transparency is the cornerstone of our relationship with you.
              Every milligram of precious metals or silver you purchase is backed by physical metal stored in secure,
              world-class vaults and verified through an independent Digital Precious Metals Trustee structure.
            </p>
            <p className="tc-p">
              CoinBazaar powered by eBullion provides a fully transparent digital precious metals investment platform in
              India, where each unit of digital precious metals is supported by verifiable physical reserves. Through
              independent trustee certification, third-party audits, and insured vault storage, investors
              receive true asset-backed precious metals ownership with complete physical precious metals verification.
            </p>

            <h2 className="tc-h2">Independent Digital Precious Metals Trustee Partner</h2>
            <p className="tc-p">
              We have appointed <strong>Shivam Rajesh &amp; Associates , Chartered Accountants </strong>  as our independent trustee.
              Their responsibility is to safeguard customer interests by ensuring that for every digital asset
              sold, an equal quantity of physical precious metals or silver is held securely in vaults — creating a fully
              ring-fenced, asset-backed structure independent of CoinBazaar powered by eBullion's operations.
            </p>

            <h2 className="tc-h2">Asset-Backed Precious Metals Trust Framework</h2>
            <div className="tc-trust-list">
              <div className="tc-trust-item">
                <div className="tc-trust-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
                <div>
                  <strong>100% Asset Backing</strong>
                  <p>Every purchase is matched 1:1 with LBMA/LPPM-standard (Good Delivery) physical precious metals, silver, platinum, or palladium bullion.</p>
                </div>
              </div>
              <div className="tc-trust-item">
                <div className="tc-trust-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
                <div>
                  <strong>Independent Audits in India</strong>
                  <p>Vault holdings are regularly audited by trusted third-party firms to verify purity and quantity.</p>
                </div>
              </div>
              <div className="tc-trust-item">
                <div className="tc-trust-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
                <div>
                  <strong>Insured &amp; Secure Storage</strong>
                  <p>Assets are held in Sequel vaults and fully insured against theft, damage, and natural calamities.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── FAQ SECTION ── */}
        <section className="tc-faq-section">
          <h2 className="tc-faq-heading">Digital Precious Metals Safety — Frequently Asked Questions</h2>
          <div className="tc-faq-list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`tc-faq-item${openFaq === index ? ' tc-faq-item--open' : ''}`}
              >
                <button
                  className="tc-faq-question"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={openFaq === index}
                >
                  <span className="tc-faq-qtext">{faq.question}</span>
                  <span className="tc-faq-icon">{openFaq === index ? '−' : '+'}</span>
                </button>
                {openFaq === index && (
                  <div className="tc-faq-answer">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* ── CTA SECTION ── */}
        <section className="tc-cta-section">
          <div className="tc-cta-inner">
            <h2 className="tc-cta-title">Invest with Confidence</h2>
            <p className="tc-cta-sub">
              Buy 100% secure digital precious metals backed by physical assets.
            </p>
            <a
              href="https://coinbazaar.ebullion.in/"
              target="_blank"
              rel="noreferrer"
              className="tc-cta-btn"
            >
              Start Investing Now
            </a>
          </div>
        </section>

      </div>
    </PageLayout>
  );
};

export default TrusteeCertificate;